<div class="main-container">
	<div class="image-container">
		<div class="sub-image-container">
			<div [ngClass]="i === 0 ? 'cursor-pointer' : 'small-image cursor-pointer'" nz-row
				*ngFor="let image of images; let i = index" (click)="preview(i)"
				> <img *ngIf="i !== 0" (error)="imageProcessing(i)"
					style="width: 70px;height: 70px;" [src]="image.src"></div>
			<div class="small-image" nz-row *ngFor="let placeholder of placeholders"> <img
					style="width: 70px;height: 70px;" src="../../../../assets/product_rocket.svg"></div>
		</div>
		<div class="main-images-container">
			<img *ngIf="productData?.files.length && productData?.files[0].url" class="cursor-pointer" style="width: 410px; height: 410px; padding-left: 15px;" [src]="productData.files[0].url"
			(error)="imageProcessing(0)"
				(click)="preview(0)">
			<img *ngIf="!productData?.files.length || !productData?.files[0]?.url" style="width: 410px; height: 410px;" src="../../../../assets/product_rocket.svg">
		</div>
	</div>
	<div class="content-container">
		<div>
			<div class="row">
				<div>
					<div> <span class="font-highlight">{{ 'global.common.product_title' | translate }}:</span> {{
						currentLanguage === 'de' ? productData['nameDE'] : productData['nameEN'] }} </div>
				</div>
			</div>
			<div class="row">
				<div>
					<div *ngIf="role === 'buyer' && (type === 'shop' || type === 'contract' || type === 'order' || type === 'my-product' )">
						<span class="font-highlight">{{ 'global.common.table_title.price' | translate }}:</span>
							{{ (productData.pricePerPackage ? productData.pricePerPackage / (productData.packageUnit || 1) : productData.price) | currency : 'EUR' :'symbol': defaultCurrencySymbol : currentLanguage }}
					</div>
					<div *ngIf="role === 'buyer' && (type === 'shop' || type === 'contract' || type === 'order' || type === 'my-product' )">
						<span class="font-highlight">{{ 'global.common.table_title.price_per_price_unit' | translate }}:</span>
							{{ (productData['pricePerPackage'] ? productData['pricePerPackage'] : 0) | currency : 'EUR' :'symbol': defaultCurrencySymbol : currentLanguage }}
					</div>
					<div *ngIf="role === 'buyer' && (type === 'shop' || type === 'contract' || type === 'order' || type === 'my-product' )">
						<span class="font-highlight">{{ 'global.common.table_title.price_unit' | translate }}:</span>
							{{ productData['packageUnit'] || 1 }}
					</div>
				</div>
			</div>
			<div class="row">
				<div style="word-wrap: break-word;">
					<div><span class="font-highlight">{{ 'global.common.product_description' | translate }}:</span> {{
						currentLanguage === 'de' ? productData['descriptionDE'] : productData['descriptionEN'] }}</div>
				</div>
			</div>
			<div *ngIf="productData.manufacturerId" class="row">
				<div style="word-wrap: break-word;">
					<div><span class="font-highlight">{{ 'global.common.product_manufacturer_id' | translate }}:</span> {{
						productData['manufacturerId'] }}</div>
				</div>
			</div>
			<div *ngIf="productData.internalArticleId" class="row">
				<div style="word-wrap: break-word;">
					<div><span class="font-highlight">{{ 'global.common.product_internal_article_id' | translate }}:</span> {{
						productData['internalArticleId'] }}</div>
				</div>
			</div>
			<div class="row">
				<div style="word-wrap: break-word;">
					<div><span class="font-highlight">{{ 'global.common.minimum_order_volume' | translate }}:</span> {{
						productData['minimumOrderVolume'] || 1}}</div>
				</div>
			</div>
			<div class="row">
				<h4 *ngIf="role === 'buyer'"> {{ 'global.common.from' | translate }} <a>{{
					productData['organizationName'] }}</a>
				<span *ngIf="type === 'shop'">
					{{ 'global.common.also_available' | translate }}
					<a class="supplier-dropdown" [nzOverlayClassName]="'dropdown'" [nzVisible]="true"
						nz-dropdown [nzDropdownMenu]="menu" [nzPlacement]="'bottomCenter'">
						{{ productData['suppliers'].length }} {{ 'global.common.other_suppliers' | translate }}
					</a>
					<nz-dropdown-menu [ngClass]="!productData['suppliers'].length ? 'hidden' : 'dropdown'"
						#menu="nzDropdownMenu">
						<ul nz-menu>
							<li class="list-item" *ngFor="let supplier of productData['suppliers']"><span> {{
									supplier?.organizationName }}</span> {{ supplier?.price | currency : 'EUR'
								:'symbol':'.2-2': currentLanguage }}</li>
						</ul>
					</nz-dropdown-menu>
				</span>
			</h4>
			</div>
		</div>
	</div>

</div>

<div class="action-container" *ngIf="role === 'buyer'">
	<div *ngIf="type === 'shop'">
		<button *appUserRole="'tender_create'" nz-button class="mr-1 border-radius-5 color-blue border-color-blue"
		nzSize='large' (click)="addProductToTender()">
		<i nz-icon nzType="plus"></i>{{ "global.buyer.shop.add_to_tender" | translate }}</button>
	</div>
	<div *ngIf="type === 'shop' || type === 'contract'">
		<!--<button nz-button class="border-radius-5 color-blue border-color-blue" nzSize='large'>
			<i nz-icon nzType="plus"></i>{{"global.buyer.shop.add_to_cart" | translate }}</button>-->
			<button *ngIf="!productData['addedToCart'] && (productData['price'] || productData['contract'])" nz-button
								(click)="addProductToCart(productData)"
								class="mt-0_5 border-radius-5 color-blue border-color-blue" nzSize='large'><i nz-icon
									nzType="plus"></i>{{ "global.buyer.shop.add_to_cart" | translate }}</button>

			<button *ngIf="productData['addedToCart'] && (productData['price'] || productData['contract'])" nz-button
								class="mt-0_5 border-radius-5 color-green btn-green-outline"  nzSize='large'><i nz-icon nzType="check"
									nzTheme="outline"></i>{{ "global.buyer.shop.added_to_cart" | translate }}</button>
	</div>
</div>
